import { createContext } from 'react';

// Public-site variant flag: the public docs page wraps its content in <DocVariantContext.Provider value>
// so DocContent / Media render the reference (Trinity) markup. Editor/review screens never set it.
export const DocVariantContext = createContext(false);
